/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import '../../../assets/styles/ChannelList.css'
import { Link } from 'react-router-dom'
import ChannelingCard from './ChannelingCard';
import { POST } from '../../../helpers/httphelper';
import Spinner from './Spinner';


function ChannelingList(props) {
    const userid = localStorage.getItem("user")
    const [channelings, SetChannelings] = useState()
    const [keyword, setKeyword] = useState('')
    const [date, setDate] = useState('')
    const [loading, setloading] = useState(false)
    const [loading2, setloading2] = useState(false)
    const [tokens, settokens] = useState([])

    useEffect(() => {
        getAll()
    }, [])

    const getAll = () => {
        setloading(true)
        POST("api/channeling/all", { userid }).then(data => {
            SetChannelings(data)
            setloading(false)
        }).catch(err => {
            console.log(err)
        })
    }

    const completed = () => {
        POST("api/channeling/completed", { userid }).then(data => {
            SetChannelings(data)
        }).catch(err => {
            console.log(err)
        })
    }

    const yetToVisit = () => {
        POST("api/channeling/yettovisit", { userid }).then(data => {
            SetChannelings(data)
        }).catch(err => {
            console.log(err)
        })
    }

    const searchfromKeyword = () => {
        const ob = {
            keyword,
            userid
        }
        POST("api/channeling/search", ob).then(data => {
            SetChannelings(data)
        }).catch(err => {
            console.log(err)
        })
    }

    const reset = () => {
        getAll()
    }
    const searchfromDate = () => {
        const mdate = new Date(date)
        const ob = {
            date: mdate,
            userid
        }
        POST("api/channeling/searchdate", ob).then(data => {
            SetChannelings(data)
        }).catch(err => {
            console.log(err)
        })
    }
    const getTokens = () => {
        setloading2(true)
        POST("api/token/gettokens", { userid }).then(data => {
            settokens(data)
            setloading2(false)
        }).catch(err => {
            console.log(err)
        })
    }

    const showmodal = () => {
        getTokens()
        document.getElementById("modals").classList.add("is-active")
    }

    const hidemodal = () => {

        document.getElementById("modals").classList.remove("is-active")
    }

    const deletetoken = (tid) => {
        POST("api/token/deletetoken", { userid, tid }).then(data => {
            getTokens()
        }).catch(err => {
            console.log(err)
        })
    }
    return (
        <div className='container'>
            <div className='columns'>
                <div className='column is-12'>
                    <h1 className='title is-2 mt-4 has-text-centered'>Channeling List</h1>
                </div>
            </div>
            <div className='columns is-justify-content-center is-multiline is-mobile'>
                <div className='column is-4-desktop is-6-tablet is-10-mobile'>
                    <div className='box main-box'>
                        <h1 className='has-text-centered mb-5'>
                            <Link to='/addchanel'>
                                <button class="button is-primary">
                                    <span class="icon">
                                        <i class="fas fa-plus-circle"></i>
                                    </span>
                                    <span>Add New</span>
                                </button>
                            </Link>
                            <button class="button is-info ml-4" onClick={(e) => { reset() }}>
                                <span class="icon">
                                    <i class="fas fa-redo"></i>
                                </span>
                                <span>Reset</span>
                            </button>
                            <button class="button is-success ml-4" onClick={(e) => { showmodal() }}>
                                Tokens
                            </button>



                        </h1>
                        <div className='field'>
                            <label className="label">Search By Keyword</label>
                            <div class="field is-grouped">
                                <p class="control is-expanded">
                                    <input class="input" type="text" onChange={(e) => { setKeyword(e.target.value) }} placeholder="Enter Keyword" />
                                </p>
                                <p class="control">
                                    <a href class="button is-info" onClick={(e) => { searchfromKeyword() }}>
                                        <i class="fas fa-search"></i>
                                    </a>
                                </p>
                            </div>
                        </div>




                        <div className='field mb-5'>
                            <label className="label">Search By Date</label>
                            <div class="field is-grouped">

                                <p class="control is-expanded">
                                    <input class="input" type="date" onChange={(e) => { setDate(e.target.value) }} placeholder="Select Keyword" />
                                </p>

                                <p class="control">
                                    <a href class="button is-info" onClick={(e) => { searchfromDate() }}>
                                        <i class="fas fa-search"></i>
                                    </a>
                                </p>
                            </div>
                        </div>

                        <div className='box'>
                            <h1 className='title is-5 has-text-centered'>Filter By</h1>
                            <div class="control has-text-centered">
                                <label class="radio">
                                    <input type="radio" className='mr-4 mb-4' onClick={(e => { completed() })} name="answer" />
                                    Completed
                                </label>
                                <br />
                                <label class="radio">
                                    <input type="radio" onClick={e => { yetToVisit() }} className='mr-5 mb-4' name="answer" />
                                    Yet to Visit
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='column is-8-desktop is-10-tablet is-12-mobile'>
                    <div className='columns is-justify-content-center is-multiline is-mobile'>
                        {loading ? <>

                            <div className='column is-2'>
                                <Spinner />
                            </div>
                        </> : <>
                            {channelings?.length === 0 ? <>
                                <h1 className='subtitle has-text-centered'>No Channelings Available</h1>

                            </> : <>

                                {channelings?.map((m, i) => (
                                    <ChannelingCard channel={m} />
                                ))}
                            </>}
                        </>}

                    </div>
                </div>
            </div>

            <div className="modal" id="modals">
                <div className="modal-background"></div>
                <div className="modal-card">
                    <header className="modal-card-head has-background-success">
                        <p className="modal-card-title has-text-centered" style={{ color: "white" }}>Tokens</p>
                        <button className="delete" aria-label="close" onClick={(e) => { hidemodal() }}></button>
                    </header>
                    <section className="modal-card-body">
                        <div className='columns is-justify-content-center'>
                            {loading2 ? <>

                                <div className='column is-2'>
                                    <Spinner />

                                </div>
                            </> : <>

                                {tokens?.length === 0 ? <>
                                    <h1 className='subtitle has-text-centered'>No Tokens Available</h1>
                                </> : <>


                                    <div className='column is-10'>
                                        <table className='table is-striped is-hoverable'>
                                            <thead>
                                                <tr>
                                                    <th>No</th>
                                                    <th>Expire Date</th>
                                                    <th>Lab Tests</th>
                                                    <th>Medicines</th>
                                                    <th>Token</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {tokens?.map((m, i) => (
                                                    <tr key={i}>
                                                        <td>{(i + 1)}</td>
                                                        <td>{m.expire}</td>
                                                        <td>{m.lab.toString()}</td>
                                                        <td>{m.medicine.toString()}</td>
                                                        <td><span className='tag is-link'>{m.token}</span></td>
                                                        <td><button className='button is-danger is-small' onClick={(e) => { deletetoken(m._id) }}><i class="fas fa-times"></i></button></td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </>}
                            </>}

                        </div>
                    </section>

                </div>
            </div>
        </div>
    );
}

export default ChannelingList;